import Entity from '@/common/models/entity'

export default class Candidate extends Entity {
  public email = ''
  public salutation = ''
  public title = ''
  public firstName = ''
  public lastName = ''
  public city = ''
  public dateOfBirth = ''
  public age: number | null = null
  public maritalStatus = ''
  public evaluationId!: string
  public professionalImpression = ''
  public personalImpression = ''
  public availabilityAndCompensation = ''
  public conclusion = ''
}
